module.exports = __webpack_public_path__ + "8688bede6d02ade786b175d22e1d1766.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/questions/speaking/assets/lovely.png
// module id = 542
// module chunks = 0